/** Gold line-art ornament: two intertwined hearts (mockup style). */
export default function HeartOrnament({ className = '' }: { className?: string }) {
  return (
    <svg
      className={`cd-ornament ${className}`.trim()}
      viewBox="0 0 120 90"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M30 48c-8-10-8-22 2-28 7-4 15-1 18 7 3-8 11-11 18-7 10 6 10 18 2 28l-20 22L30 48z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.85"
      />
      <path
        d="M52 48c-8-10-8-22 2-28 7-4 15-1 18 7 3-8 11-11 18-7 10 6 10 18 2 28l-20 22L52 48z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.85"
      />
      <path
        d="M40 70c4 6 12 10 20 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.5"
      />
    </svg>
  );
}
